<template>
  <v-card flat xs12>
    <v-layout class="align-start">
      <v-text-field append-icon="search" :placeholder="$t('private_global.filter')" single-line hide-details v-model="search"></v-text-field>
      <!-- <v-alert v-else :value="true" outline color="primary" icon="info" style="border:none !important" v-html="$t('private_dash_table_earnings_nodata')"> </v-alert> -->

      <v-btn fab right class="ml-5" flat @click="createOwner">
        <v-icon color="primary">add</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="computedHeaders"
      :items="owners"
      :total-items="totalEvents"
      :pagination.sync="pagination"
      :loading="isLoading"
      :rows-per-page-items="[5, 10, 25, 50]"
      :hide-headers="hideActions"
      :hide-actions="hideActions"
      :rows-per-page-text="paginationText"
      expand
    >
      <template slot="items" slot-scope="props">
        <tr style="cursor: pointer;" :class="{ 'wsp-no-border': props.expanded, 'wsp-disabled-row': !props.item.enabled }" @click="props.expanded = !props.expanded">
          <td v-if="!$vuetify.breakpoint.mdAndDown">{{ props.item.name }}</td>
          <td>{{ props.item.teletagLabel }} {{ props.item.email }}</td>
          <td>{{ props.item.keypad }}</td>
          <td v-if="!$vuetify.breakpoint.mdAndDown">{{ props.item.start | formatDate }}</td>
          <td v-if="!$vuetify.breakpoint.mdAndDown">{{ noDateText(props.item.end) }}</td>

          <td style="width:70px">
            <v-icon class="right" v-if="props.expanded">keyboard_arrow_up</v-icon>
            <v-icon class="right" v-else>keyboard_arrow_down</v-icon>
          </td>
        </tr>
      </template>

      <template slot="expand" slot-scope="props">
        <v-card pa-2 :key="props.id" flat :class="{ 'wsp-disabled-row': !props.item.enabled }">
          <v-layout wrap row pl-5 pt-3>
            <v-flex xs12>
              <div class="pb-1" v-if="props.item.name && $vuetify.breakpoint.mdAndDown">
                <strong>{{ $t('private_global_name') }}:</strong>
                {{ props.item.name }}
              </div>
              <div class="pb-1" v-if="props.item.teletagLabel && $vuetify.breakpoint.mdAndDown">
                <strong>{{ $t('private_global_teletag') }}:</strong>
                {{ props.item.teletagLabel }}
              </div>
              <div class="pb-1" v-if="props.item.keypad && $vuetify.breakpoint.mdAndDown">
                <strong>{{ $t('private_global_keypad') }}:</strong>
                {{ props.item.keypad }}
              </div>
              <div class="pb-1" v-if="props.item.email && $vuetify.breakpoint.mdAndDown">
                <strong>{{ $t('private_global_email') }}:</strong>
                {{ props.item.email }}
              </div>
              <div class="pb-1" v-if="props.item.description">
                <strong>{{ $t('private_global_description') }}:</strong>
                {{ props.item.description }}
              </div>
              <div class="pb-1" v-if="$vuetify.breakpoint.mdAndDown">
                <strong>{{ $t('private_global_start') }}:</strong>
                {{ props.item.start | formatDate }}
              </div>
              <div class="pb-1" v-if="$vuetify.breakpoint.mdAndDown">
                <strong>{{ $t('private_global_end') }}:</strong>
                {{ noDateText(props.item.end) }}
              </div>
              <div class="pb-1" v-if="props.item.spot">
                <strong>{{ $t('private_global_spot') }}:</strong>
                {{ props.item.spot }}
              </div>
              <div class="pb-1" v-if="props.item.enabled">
                <strong>{{ $t('private_global_enabled') }}:</strong>
                {{ $t('private_global_yes') }}
              </div>
              <div class="pb-1" v-else>
                <strong>{{ $t('private_global_enabled') }}:</strong>
                {{ $t('private_global_no') }}
              </div>
              <v-layout row class="justify-space-between mb-2 mt-3">
                <v-btn flat small color="error" dark @click="deleteDialog(props.item)">{{ $t('global_button_remove') }}</v-btn>
                <v-btn flat small color="primary" v-if="props.item.email === ''" dark @click="editOwner(props.item)">{{ $t('global_button_edit') }}</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </template>

      <template slot="no-data">
        <v-alert :value="true" outline color="info" class="mt-3" v-html="$t('private_dash_table_earnings_nodata')"> </v-alert>
      </template>
    </v-data-table>

    <v-layout row justify-center>
      <v-dialog v-model="showDeleteDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{ $t('private_remove_owner_modal_title') }}</v-card-title>
          <v-card-text v-html="$t('private_remove_owner_modal_text')"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="showDeleteDialog = false">{{ $t('global_button_cancel') }}</v-btn>
            <v-btn color="primary" flat @click.native="remove(elementSelected)">{{ $t('global_button_remove') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-dialog v-model="showEditModal" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click.native="closeEditModal" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('private_tenant_title_editOwner') }}</v-toolbar-title>
        </v-toolbar>
        <edit-tenant ref="editTenant" @close="closeEditModal"></edit-tenant>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCreateModal" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click.native="closeCreateModal" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('private_tenant_title_createOwner') }}</v-toolbar-title>
        </v-toolbar>

        <create-tenant ref="createTenant" :hasBle="this.hasBle" :hasRfid="this.hasRfid" @close="closeCreateModal"></create-tenant>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import tenantService from '@/services/tenantService';
import CreateTenant from '@/components/parking/CreateTenant';
import EditTenant from '@/components/parking/EditTenant';
import store from '@/store';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import _ from 'lodash';

export default {
  name: 'Owners',
  props: ['parkingData'],
  components: {
    [CreateTenant.name]: CreateTenant,
    [EditTenant.name]: EditTenant
  },
  computed: {
    // @see: https://codepen.io/anon/pen/bMQGbm
    computedHeaders() {
      return this.headers.filter(h => !h.hide || !this.$vuetify.breakpoint[h.hide]);
    },
    hideActions() {
      return this.totalEvents === 0;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.queryChange();
      },
      deep: true
    },

    parkingData: function(newValue) {
      this.hasBle = newValue.hasBle;
      this.hasRfid = newValue.hasRfid;
    },

    search: function(newValue) {
      let l = newValue.trim().length;
      if (l > 3 || l === 0) {
        this.debounceSearch();
      }
    }
  },
  data() {
    return {
      debounceSearch: {},
      owners: [],
      showDeleteDialog: false,
      elementSelected: undefined,
      totalEvents: 0,
      search: '',
      showAll: true,
      paginationText: '',
      isLoading: false,
      showCreateModal: false,
      showEditModal: false,
      editingRule: null,
      hasBle: true,
      hasRfid: true,
      pagination: {
        rowsPerPage: 10,
        descending: true,
        sortBy: 'id'
      },
      headers: [
        {
          i18nText: 'private_global_name',
          text: this.$i18n.t('private_global_name'),
          align: 'left',
          value: 'name',
          hide: 'mdAndDown'
        },
        {
          i18nText: 'private_global_teletag',
          text: this.$i18n.t('private_global_teletag_username'),
          align: 'left',
          value: 'teletagLabel'
        },
        {
          i18nText: 'private_global_keypad',
          text: this.$i18n.t('private_global_keypad'),
          align: 'left',
          value: 'keypad'
        },
        {
          i18nText: 'private_global_start',
          text: this.$i18n.t('private_global_start'),
          align: 'left',
          value: 'start',
          hide: 'mdAndDown'
        },
        {
          i18nText: 'private_global_end',
          text: this.$i18n.t('private_global_end'),
          align: 'left',
          value: 'end',
          hide: 'mdAndDown'
        },
        { value: '' } // actions column
      ]
    };
  },
  created() {
    this.debounceSearch = _.debounce(this.queryChange, 500);
    EventBus.$on(keys.eventOnLanguageChanged, this.updateLanguage);
  },

  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateLanguage);
  },

  methods: {
    loadData(params) {
      tenantService.list(params, this.successHandler, this.errorHandler);
    },

    closeEditModal() {
      this.showEditModal = false;
      this.queryChange();
    },

    closeCreateModal() {
      this.showCreateModal = false;
      this.queryChange();
    },

    deleteDialog(item) {
      this.elementSelected = item;
      this.showDeleteDialog = true;
    },

    async remove(rule) {
      let params = {
        whitelistRuleId: rule.id,
        parkingId: Number(this.$route.params.id)
      };

      let resp = await tenantService.deleteTenant(params);
      if (typeof resp.error === 'undefined') {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'private_owner_delete_success',
          type: 'success',
          doNotTranslate: false
        });
      } else {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: resp.error,
          type: 'error',
          doNotTranslate: true
        });
      }
      this.showDeleteDialog = false;
      this.queryChange();
    },

    queryChange() {
      this.isLoading = true;

      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      let queryInfo = {
        pageSize: rowsPerPage,
        page: page,
        sortInfo: {
          column: {
            sortBy: sortBy,
            order: descending ? 'descending' : 'ascending'
          }
        }
      };

      let params = {
        parkingId: this.$route.params.id,
        length: queryInfo.pageSize,
        start: (queryInfo.page - 1) * queryInfo.pageSize,
        lang: store.state.langSelected.langWsp,
        term: this.search,
        sortBy: sortBy,
        descending: descending,
        showAll: this.showAll
      };

      this.loadData(params);
    },

    successHandler(data) {
      this.isLoading = false;
      this.owners = data.data;
      this.totalEvents = data.recordsTotal;
    },

    errorHandler() {},

    createOwner() {
      this.showCreateModal = true;
    },

    editOwner(rule) {
      this.$refs.editTenant.reset();
      this.$refs.editTenant.setRule(rule);
      this.editingRule = rule;
      this.showEditModal = true;
    },

    noDateText(v) {
      let date = this.$options.filters.formatDate(v);
      if (date === '') {
        return this.$i18n.t('global.noEndDate');
      }
      return date;
    }
  }
};
</script>

<style>
.wsp-no-border {
  border-bottom: none !important;
}
.wsp-disabled-row {
  background-color: #d3d3d354 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/parking/Owners.vue